import React from 'react';

import ActivityTypeFilter from './activity_type';
import BrokerFilter from './broker';
import DateFilter from './date_filter';
import FilterTags from './filter_tags';
import ParentTypeFilter from './parent_type';
import QueryFilter from './query';

import type { FilterOptions } from 'bundles/apex/activities/types';
import type { Filters } from './types';

import 'components/styles/search_page.scss';
import './styles.scss';

export interface Props {
  filterOptions?: FilterOptions;
  filters: Filters;
  show?: boolean;
  onChange: (changes: Partial<Filters>, debounce?: boolean) => void;
}

export default function ActvitiesFilters({ filterOptions, filters, show, onChange }: Props) {

  if (!show) {
    return null;
  }

  const filterProps = { ...filters, onChange };

  return (
    <div className="apex-activities-filter search-page flex-column">
      <div className="d-flex gap-2 w-100">
        <QueryFilter {...filterProps} onChange={changes => onChange(changes, true)} />
        <ParentTypeFilter {...filterProps} />
        <ActivityTypeFilter {...filterProps} />
        {filterOptions && filterOptions.brokers.length > 1 &&
          <BrokerFilter {...filterProps} brokerOptions={filterOptions.brokers} />}
        <DateFilter {...filterProps} />
      </div>
      <FilterTags filterOptions={filterOptions} filters={filters} onChange={onChange} />
    </div>
  );
}
